/* eslint-disable react/react-in-jsx-scope */
import { Link, useNavigate, redirect } from "react-router"
import { useState, useEffect } from "react";
// import { useAuth } from "./AuthProvider";
// import { useUser, useUserDispatch } from '../contexts/UserContext';
import { useUserContext, useUserDispatch } from '../contexts/UserContext';
import axios from 'axios';
import { enCrypt, deCrypt, aesEncrypt, aesDecrypt } from "../api/enCrypt";


function Login() {

  // useEffect(() => {
  //   const connection = createConnection(serverUrl, roomId);
  //   connection.connect();
  //   return () => {
  //     connection.disconnect();
  //   };
  // }, [serverUrl, roomId]);

  // const user = useUser();
  // const userdispatch = useUserDispatch();
  // const auth = useAuth();

    const user = useUserContext();
    const dispatch = useUserDispatch();

  const [input, setInput] = useState({
    email: "",
    password: "",
  });
  const [err, setErr] = useState("");
  const navigate = useNavigate();

  
  const handleSubmitEvent = async (e) => {
    e.preventDefault();
    setErr("getting data...");

    if (input.email !== "" && input.password !== "") {


      const fetchUsers = async () => {
        try {

          // const token = enCrypt(JSON.stringify(input.password));
          let p = input.email + input.password;
          // console.log(p);
          const token = aesEncrypt(p);
          // const token = enHMAC_SHA256(input.password);
          // console.log(token);
          // console.log(aesDecrypt(token));
          // console.log(deCrypt(token));
          const formData = {
            "email": input.email,
            "token": token ,
            "mode": 'login',
          }


          // const response = await fetch("/user.json"); // Path to your JSON file
          //const response = await axios.get(`https://pos.freelance.in.th/api/login.php?mode=getemail&email=${input.email}&password=${input.password}`);
          const response = await axios({
                                    method: 'post',
                                    url: `${process.env.REACT_APP_API}/login.php`,
                                    headers: {
                                        'Accept': 'application/json',
                                        // 'Content-type': 'application/x-www-form-urlencoded',
                                        // 'Content-type': 'application/json; charset=utf-8',
                                        'Content-Type': 'multipart/form-data'
                                    },
                                    data: JSON.stringify(formData) ,
                                });
            
          // const res = await axios({
          //                     method: 'get',
          //                     url: `https://pos.freelance.in.th/api/users.php?mode=list`,
          //                     headers: {
          //                         'Accept': 'application/json',
          //                         'Content-Type': 'application/json; charset=utf-8'
          //                     }
          //                 });
               const data = response.data;
                //  console.log(data);
                //  console.log(response);

          // if(data.length>0 && Object.keys(data).length !== 0) {
            if(data.message=="OK" && data.data) {
              // const data = await response.json();
              // console.log(data);
              // setUsers(response.data[0]);
              dispatch({
                type: 'login',
                user: data.data[0],
              });

              setErr("");

              if(data.data[0].isAdmin==1) {
                navigate("/pos");
              } else if(data.data[0].Role==='User') {
                navigate("/pos/products");
              } else {
                navigate("/shop");
              }

              return data;
        
          }else {
            setErr("please provide a valid input");
          }
        } catch (error) {
          console.error("Error fetching users:", error);
          setErr("!!!Error fetching users!!!");

        }
      };

      fetchUsers();

      // navigate("/pos");

      // await auth.loginAction(input);
      // userdispatch({
      //   type: 'login',
      //   input
      //   });

        // console.log(auth)

        // if(user===null) {
        //   setErr("User & Password not found!!!")
        // }
  
      // if(auth.user===null) {
        // setErr("User & Password not found!!!")
      // }

    }
    // alert("please provide a valid input");
            // return redirect("/");

  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErr('Typing...');
  };

 

  return (
    <div className="flex min-h-screen flex-1 flex-col justify-center px-6 py-12 lg:px-8 bg-slate-900">
        <Link to="/">
            <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <img
                alt="Dang Bakery&Chiffon"
                src="/logo.jpg"
                className="mx-auto h-36 w-auto rounded-2xl"
            />
            <h2 className="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-300">
                Sign in to your account
            </h2>
            </div>
        </Link>
        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form onSubmit={handleSubmitEvent} method="POST" className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm/6 font-medium text-gray-400">
                Email address
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  autoComplete="email"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-600 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  onChange={handleInput}
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label htmlFor="password" className="block text-sm/6 font-medium text-gray-400">
                  Password
                </label>
                <div className="text-sm">
                  <Link to="/" className="font-semibold text-indigo-400 hover:text-indigo-500">
                    Forgot password?
                  </Link>
                </div>
              </div>
              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  required
                  autoComplete="off"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-600 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  onChange={handleInput}
                 />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Sign in
              </button>
            </div>
          </form>

          <p className="mt-10 text-center text-sm/6 text-gray-400">
            Not a member?{' '}
            <Link to="/register" className="font-semibold text-indigo-400 hover:text-indigo-500">
              Register
            </Link>
          </p>
        <p className="text-red-700">{err}</p>
        </div>
      </div>
  )
}

export default Login